import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  imports: [],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModalComponent {
  // Writable signals used instead of input() because NgbModal sets values
  // imperatively via componentInstance — signal inputs are read-only.
  readonly title = signal('Confirm');
  readonly message = signal('Are you sure?');
  readonly confirmButtonText = signal('Confirm');
  readonly cancelButtonText = signal('Cancel');
  readonly alertClasses = signal('alert-warning');
  readonly showCancelButton = signal(true);
  readonly confirmButtonClass = signal('btn-danger');
  readonly alertIcon = signal('');

  private readonly activeModal = inject(NgbActiveModal);

  confirm(): void {
    this.activeModal.close(true);
  }

  cancel(): void {
    this.activeModal.dismiss(false);
  }
}
